<template>
    <div v-if="dataOrder && dataGeneral">
        <hts-card
            :title="$t('labels.generalInformation')"
            class="mb-2">
            <hts-form-radio
                v-model="dataOrder.createOrderFrom"
                label-key="label"
                value-key="value"
                :items="listOrderFrom"
                readonly
                name="createOrderFrom"
                prop="createOrderFrom" />

            <div class="grid gap-x-2 grid-cols-4">
                <hts-form-input
                    v-if="dataOrder.createOrderFrom === 'QUOTE'"
                    v-model="dataOrder.quoteCode"
                    :label="$t('labels.quote')"
                    readonly />
            </div>

            <div>
                <div class="grid gap-x-2 grid-cols-4">
                    <hts-form-input
                        v-model="dataOrder.customerName"
                        :label="$t('labels.customer')"
                        readonly />
                    <hts-form-input
                        v-model="dataOrder.contactName"
                        :label="$t('labels.businessContact')"
                        readonly />
                    <hts-form-input
                        v-model="dataOrder.contactEmail"
                        :label="$t('labels.email')"
                        readonly />
                    <hts-form-input
                        v-model="dataOrder.contactPhone"
                        :label="$t('labels.phone')"
                        readonly />
                </div>

                <div class="grid gap-x-2 grid-cols-4">
                    <div />
                    <hts-form-input
                        v-model="dataOrder.logisticContactName"
                        :label="$t('labels.logisticContact')"
                        readonly />
                    <hts-form-input
                        v-model="dataOrder.logisticContactEmail"
                        :label="$t('labels.email')"
                        readonly />
                    <hts-form-input
                        v-model="dataOrder.logisticContactPhone"
                        :label="$t('labels.phone')"
                        readonly />
                </div>
            </div>

            <div class="grid gap-x-2 grid-cols-2">
                <hts-form-input
                    v-model="dataGeneral.businessOpportunityName"
                    :label="$t('labels.businessOpportunity')"
                    readonly />
                <hts-form-input
                    v-model="dataGeneral.commodityName"
                    :label="$t('labels.commodity')"
                    readonly />
            </div>

            <div class="flex gap-2">
                <hts-form-input
                    v-if="dataOrder.truckOrderCode"
                    v-model="dataOrder.truckOrderCode"
                    label="Truck Order"
                    readonly
                    class="w-full" />

                <hts-form-input
                    v-if="dataOrder.containerCode"
                    v-model="dataOrder.containerCode"
                    :label="$t('labels.container')"
                    readonly
                    class="w-full" />
            </div>

            <hts-form-input
                v-model="dataGeneral.workflowName"
                :label="$t('labels.workflow')"
                readonly />

            <ul
                v-if="dataOrder.positions && dataOrder.positions.length"
                class="steps steps-vertical w-full">
                <li
                    v-for="(item, index) in dataOrder.positions"
                    :key="index"
                    class="pl-10 step w-full">
                    <div class="flex items-center justify-center w-full">
                        <span class="w-52 flex justify-start">
                            {{ item.nodeTypeName }}
                        </span>
                        <div class="flex items-center w-full gap-5">
                            <hts-form-input
                                v-model="item.fullNameNode"
                                class="w-full"
                                readonly />

                            <hts-form-button
                                icon-name="hi-eye-icon"
                                size="small"
                                class="w-96"
                                color="info"
                                @click="() => openWorkflowPosition(item)">
                                {{ $t('labels.viewTaskInfo') }}
                            </hts-form-button>
                        </div>
                    </div>
                </li>
                <!--
                  <div class="text-right">
                  <span
                  class="right-20 text-lg text-blue-600 cursor-pointer italic"
                  @click="openWithMap">
                  {{ $t('labels.openWithMap') }}
                  </span>
                  </div>
                -->
            </ul>

            <hts-form-input
                v-model="dataOrder.noBooking"
                :label="$t('labels.noBooking')"
                readonly />

            <div>
                <div v-if="dataOrder.transportation === 'CONTAINER'">
                    <hts-form-input
                        v-model="dataOrder.contCategory"
                        :label="$t('labels.cont')"
                        readonly />
                    <p class="mt-2">
                        {{ $t('labels.requestSpecial') }}
                    </p>
                    <div class="flex">
                        <hts-form-checkbox
                            v-if="dataOrder.contCategory === 20"
                            v-model="dataOrder.mergeContainer"
                            color="secondary"
                            readonly
                            :items="[{ label: $t('labels.mergeContainer'), value: false }]" />
                        <hts-form-checkbox
                            v-model="dataOrder.headContainer"
                            color="secondary"
                            readonly
                            :items="[{ label: $t('labels.headContainer'), value: false }]" />
                    </div>
                </div>
                <div v-else-if="dataOrder.transportation === 'NON_CONTAINER'">
                    <hts-form-input
                        v-model="dataOrder.vehicleCategoryName"
                        :label="$t('labels.vehicleType')"
                        readonly />
                </div>
                <hts-form-input
                    v-model="dataGeneral.productivity"
                    :label="$t('labels.productivityByMount')"
                    type="number"
                    readonly>
                    <template #suffix>
                        <span>
                            {{ dataOrder.transportation ? (dataOrder.transportation === 'CONTAINER' ? $t('labels.cont') : $t('labels.vehicle')) : '-' }}
                        </span>
                    </template>
                </hts-form-input>
                <hts-form-input
                    v-model="dataGeneral.weightCommodity"
                    :label="$t('labels.weightCommodityByKG1')"
                    type="number"
                    readonly
                    prop="weightCommodityByKG"
                    name="weightCommodityByKG1">
                    <template #suffix>
                        <span>
                            {{ dataOrder.transportation ? (dataOrder.transportation === 'CONTAINER' ? $t('labels.cont') : $t('labels.vehicle')) : '-' }}
                        </span>
                    </template>
                </hts-form-input>

                <hts-form-checkbox
                    v-if="numberWarehouseNode"
                    v-model="dataOrder.workingTimeRequest"
                    :label="$t('labels.requireWorkingTimeWarehouse')"
                    :items="listWorkingTimeRequest"
                    readonly />

                <hts-form-input
                    v-model="dataOrder.productivityOrder"
                    required
                    type="number"
                    prop="productivityOrder"
                    name="productivityOrder"
                    :label="$t('labels.productivityOrder')"
                    readonly>
                    <template #suffix>
                        <div class="w-10 text-center">
                            <p>
                                {{ dataOrder?.transportation === 'NON_CONTAINER' ? $t('labels.vehicle') : dataOrder?.transportation === 'CONTAINER' ? $t('labels.cont') : '-' }}
                            </p>
                        </div>
                    </template>
                </hts-form-input>

                <hts-form-textarea
                    v-model="dataOrder.request"
                    readonly
                    :label="$t('labels.requestOther')" />
            </div>
        </hts-card>
        <workflow-position ref="workflowPosition" />
        <view-position
            ref="viewPosition"
            :edit="false" />

    <!--
      <hts-card :title="$t('labels.generalInformation')" class="mb-2">
      <div v-if="dataOrder.createOrderFrom === 'QUOTE'" class="grid gap-4 grid-cols-3 ">
      <hts-select-quote
      v-model="dataOrder.quote"
      v-model:text="dataOrder.quoteCode"
      readonly
      name="quote"
      prop="quote"
      />

      <hts-form-select
      v-model="dataOrder.charge"
      v-model:text="dataOrder.chargeName"
      class="col-span-2"
      readonly
      :label="$t('labels.route')"
      :items="CCharges || []"
      key-id="_id"
      key-label="routeName"
      name="charge"
      prop="charge"
      />
      </div>
      <hts-form-input
      v-model="dataOrder.productivityOrder"
      type="number"
      readonly
      prop="productivityOrder"
      name="productivity"
      :label="$t('labels.productivity')"
      >
      <template #suffix>
      <div class="w-10 text-center">
      <p v-if="dataOrder.createOrderFrom === 'QUOTE' ">
      {{ dataOrder?.transportation === 'NON_CONTAINER' ? `${$t('labels.vehicle')}`
      : (dataOrder?.transportation === 'CONTAINER' ? `${$t('labels.cont')}` : '-') }}
      </p>
      <p v-else>
      {{
      dataOrder?.transportation === 'NON_CONTAINER'
      ? $t('labels.vehicle') : (dataOrder?.transportation === 'CONTAINER' ? `${$t('labels.cont')}` : '-')
      }}
      </p>
      </div>
      </template>
      </hts-form-input>

      <hts-form-checkbox
      v-if="numberWarehouseNode"
      v-model="dataOrder.workingTimeRequest"
      :label="$t('labels.requireWorkingTimeWarehouse')"
      :items="listWorkingTimeRequest"
      readonly
      />
      </hts-card>
    -->
    </div>
</template>
<script setup>
import WorkflowPosition from '../../../quote/quote-request/-components/workflow-position.vue'
import ViewPosition from '../../../quote/quote-request/-components/view-position.vue'
import data from '~/pages/trucker-[id]/order/ignore/imports/data'

const { $disableReactive } = useNuxtApp()
const { listOrderFrom, listWorkingTimeRequest } = data()

const props = defineProps({
  dataOrder: Object
})

const { dataOrder } = toRefs(props)

const numberWarehouseNode = ref()
const workflowPosition = ref()
const viewPosition = ref()

const dataGeneral = computed(() => {
  if (!dataOrder.value) {
    return null
  }

  if (dataOrder.value.createOrderFrom === 'QUOTE') {
    const quoteData = dataOrder.value.quoteData
    return {
      productivity: quoteData?.productivity || '',
      weightCommodity: quoteData?.weightCommodity || '',
      businessOpportunityName: quoteData?.businessOpportunityName || '',
      commodityName: quoteData?.commodityName,
      workflowName: quoteData?.workflowName || ''
    }
  }

  if (dataOrder.value.createOrderFrom === 'CUSTOMER_REQUEST') {
    return (({ productivity = '', weightCommodity = '', businessOpportunityName = '', commodityName = '', workflowName = '' }) => ({
      productivity,
      weightCommodity,
      businessOpportunityName,
      commodityName,
      workflowName
    }))(dataOrder.value)
  }

  return null
})

watch(
  () => dataOrder.value,
  (val) => {
    updateWarningTimeWorking(val?.positions || [])
  }
)

const updateWarningTimeWorking = (positions) => {
  numberWarehouseNode.value = 0
  positions.forEach((position) => {
    if (position.nodeTypeName === 'Kho') {
      numberWarehouseNode.value += 1
    }
  })
}

const openWorkflowPosition = (position) => {
  if (workflowPosition.value) {
    workflowPosition.value.open($disableReactive(position), $disableReactive(dataOrder.value), true)
  }
}

const openWithMap = () => {
  viewPosition.value && viewPosition.value.open({ positions: $disableReactive(dataOrder.value.positions) })
}
</script>
